export default {
	props: {
		hideLabelUnlessReadonly: Boolean
	},
	computed: {
		labelHidden() {
			return this.hideLabel || (this.hideLabelUnlessReadonly && !this.$source.readonly);
		},
		showLabel() {
			return !this.labelHidden && this.$source.label && this.$source.label.trim().length;
		}
	}
};
